import { AxiosResponse } from 'axios'
import { API } from '../../../common/api'
import {
  azureEngineServiceUrl,
  cloudAccountServiceUrl,
  identityServiceUrl,
} from '../../../common/utils/constants'
import { Account } from '../../../common/modules/cmcm/types'
import { CloudType } from '../../../common/modules/types'
import { ProductType } from '../../../common/modules/partner/reducer'

export const getUrlFromCloudAccount = (partnerId: string) => {
  return API.get(
    `${azureEngineServiceUrl}/oauth/${partnerId}/auth_response/azure`
  )
}
export const sendAzureData = (
  dataToSend: Record<string, unknown>,
  partnerId: string
) => {
  return API.post(
    `${azureEngineServiceUrl}/oauth/${partnerId}/tokens/azure`,
    dataToSend
  )
}
export const sendAzurePartnerData = (
  dataToSend: Record<string, unknown>,
  partnerId: string
) => {
  return API.put(`${azureEngineServiceUrl}/partners/${partnerId}`, dataToSend)
}

export const sendAzureSolutionsData = (
  dataToSend: Record<string, unknown>,
  partnerId: string
) => {
  return API.put(
    `${azureEngineServiceUrl}/partners/${partnerId}/solutions`,
    dataToSend
  )
}

export const postFlyoutAccountDetails = (data: Record<string, unknown>) => {
  return API.post(`${cloudAccountServiceUrl}/accounts`, data)
}

/**
 * Cloud account service /accounts is deprecated.
 * Returns empty rows without calling the API.
 */
export const fetchOrganizationAccounts = (
  _organizationId: string,
  _cloudType: CloudType,
  _productId?: ProductType
): Promise<AxiosResponse<{ rows: Account[] }>> =>
  Promise.resolve({
    data: { rows: [] },
    status: 200,
    statusText: 'OK',
    headers: {},
    config: {} as AxiosResponse<{ rows: Account[] }>['config'],
  } as AxiosResponse<{ rows: Account[] }>)

export const patchAccount = (accountId: string, data: unknown) => {
  return API.patch(`${cloudAccountServiceUrl}/accounts/${accountId}`, data)
}

export const testTemplateEndpoint = (
  templateId: string,
  cloudType: CloudType,
  iamRoleArn: string,
  partnerId: string
) => {
  return API.get(
    `${cloudAccountServiceUrl}/templates/${templateId}/verifications`,
    {
      params: {
        cloud_type: cloudType,
        iam_role_arn: iamRoleArn,
        partner_id: partnerId,
      },
    }
  )
}
